import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

const testimonials = [
  {
    quote: "His ability to connect with an audience is more than a skill — it is truly a gift.",
    name: "Judy Burch",
    role: "American Association of Orthodontists (AAO)",
  },
  {
    quote: "More than 90% of attendees rated him 'Excellent' in nearly every category.",
    name: "Dr. Charles K. Wear",
    role: "PCSO Annual Session",
  },
  {
    quote: "Dental educators, professional speakers, and even former keynote speakers told me he was the best keynote speaker RDH Under One Roof had ever featured.",
    name: "Craig Dickson",
    role: "RDH Magazine",
  },
  {
    quote: "Attendees described him as motivational, heartfelt, inspiring, and life-changing.",
    name: "Pacific Northwest Dental Conference",
    role: "Two keynotes · 8,500 attendees · 4.9 / 5",
  },
  {
    quote: "Gary Zelesky is an edutainer — part educator, part entertainer, and the best of both.",
    name: "Dr. Craig S. Yarbrough",
    role: "University of the Pacific",
  },
  {
    quote: "The turnout was massive, our practice became re-energized, and we had our best year ever.",
    name: "Mark S. Douglas, DDS, MSD",
    role: "Referral Appreciation Event",
  },
  {
    quote: "Gary has a unique gift for touching people's hearts and minds in a positive, motivating way.",
    name: "Dr. Glenn C. Dubroc, Jr.",
    role: "New Orleans Dental Conference",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((i + 1) % testimonials.length);
  const prev = () => setI((i - 1 + testimonials.length) % testimonials.length);
  const t = testimonials[i];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative bg-[#0a0a0a] py-24 md:py-32 border-t border-[#262626]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">04 / WHAT THEY'RE SAYING</span>
          <div className="divider-red" />
        </div>
        <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mb-16">
          Words from <br />the <span className="text-[#EC1985]">room.</span>
        </h2>

        <div className="surface p-8 md:p-16 relative">
          <Quote size={60} className="text-[#EC1985] opacity-40 mb-6" />
          <blockquote
            data-testid="testimonial-quote"
            className="font-display text-3xl md:text-5xl text-white leading-tight tracking-tight"
          >
            "{t.quote}"
          </blockquote>
          <div className="mt-10 flex items-end justify-between flex-wrap gap-6">
            <div>
              <div data-testid="testimonial-name" className="text-lg font-bold text-white">{t.name}</div>
              <div className="text-sm uppercase tracking-[0.2em] text-white/60 mt-1">{t.role}</div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                data-testid="testimonial-prev"
                aria-label="Previous"
                className="border border-[#262626] p-3 hover:border-[#EC1985] hover:text-[#EC1985] transition-colors"
              >
                <ChevronLeft size={20} />
              </button>
              <span className="text-sm font-bold tracking-[0.2em] text-white/60">
                {String(i + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
              </span>
              <button
                onClick={next}
                data-testid="testimonial-next"
                aria-label="Next"
                className="border border-[#262626] p-3 hover:border-[#EC1985] hover:text-[#EC1985] transition-colors"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
